export default "__VITE_ASSET__esFu3vOr__"